import SectionHeading from "./SectionHeading";
import { topics } from "@/mocks/home";

const tintMap = {
  primary: {
    bubble: "bg-primary-100 text-primary-700",
    count: "text-primary-600",
    hover: "hover:border-primary-300",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-800",
    count: "text-accent-700",
    hover: "hover:border-accent-300",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-800",
    count: "text-secondary-700",
    hover: "hover:border-secondary-300",
  },
} as const;

export default function TopicSection() {
  return (
    <section id="topics" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <SectionHeading
          id="topics"
          kicker="主题分区"
          title="按主题分好的黑料整理索引"
          desc="黑料bu把合集拆成可浏览的主题分区，每个分区都标注了收录数量与整理角度，先选分区再进合集，查找更省事。"
          actionLabel="浏览全部分区"
          actionHref="#collections"
          actionIcon="ri-layout-grid-line"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {topics.map((topic) => {
            const tint = tintMap[topic.tint];
            return (
              <a
                key={topic.id}
                href="#collections"
                className={`hover-lift group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors ${tint.hover}`}
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-md ${tint.bubble}`}
                  >
                    <i className={`${topic.icon} w-5 h-5 flex items-center justify-center text-xl`}></i>
                  </span>
                  <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center text-lg text-foreground-300 transition-colors group-hover:text-primary-600"></i>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {topic.name}
                </h3>
                <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">
                  {topic.desc}
                </p>
                <span className={`mt-4 font-label text-xs font-medium ${tint.count}`}>
                  {topic.count}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}